import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { environment } from '@env/environment.local';

export const onboardingGuard: CanActivateFn = () => {
  if (environment.ONBOARDING_ACTIVE) {
    return true;
  }

  const router = inject(Router);
  return router.createUrlTree(['/home']);
};
